import classSezione from "../../fetch/classSezione";
import create_autocompleteWithService from "./create_autocompleteWithService";


const AutocompleteMagazzino = create_autocompleteWithService({
    freeinput: false,
    service: (myValue, serviceValues) => classSezione.get({
        magazzinoPrincipale :1 ,
        nome: myValue,
        ...serviceValues,
        autoComplite: 1
    }),
    itemCompare: (item, inputValue) => (item.nome.toLowerCase().indexOf((inputValue || "").toLowerCase()) !== -1),
    itemToLi: item => item.nome ,
    itemToString: item => item.nome,
    itemFind: (value, items) => items.reduce((acc, curr) => acc || (curr.nome.toLowerCase() === value.toLowerCase() ? curr : null), null),
});

export default AutocompleteMagazzino